import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const StyledModal = styled(Modal)`
  text-align: left;
  .modal-dialog {
    max-width: 640px;
  }
  .modal-header{
    padding-right: 32px;
    padding-left: 32px;
  }
  .modal-title{
    margin-top: 16px;
    max-width: 450px;
    text-align: left;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
  }
`;
export const HeroSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 32px 0;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const HeroSectionContent = styled.div`
  width: 60%;

  h1 {
    font-size: 56px;
    font-weight: 600;
    line-height: 1.1;
    margin-bottom: 20px;
  }

  p {
    font-size: 17px;
    color: #666;
  }

  @media (max-width: 991px) {
    h1 {
      font-size: 45px;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const HeroSectionImg = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;

  img {
    width: 90%;
    max-width: 640px;
  }

  @media (max-width: 767px) {
    position: relative;
    margin-top: -25px;
    right: -15px;
    z-index: -1;
  }
`;

export const MissionRow = styled.div`
  background-color: #e7fee5;
  padding: 32px 0;
`;

export const MissionSection = styled.div`
  width: 40%;
  max-width: 450px;
  border-radius: 20px;
  overflow: hidden;
  text-align: center;
  padding: 24px 20px;

  img {
    width: 100%;
  }

  @media (max-width: 991px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const FeatureSection = styled.div`
  padding: 24px 32px 0;
  background-color: #fff;
  border-radius: 20px;
  flex: 1;

  h3 {
    font-size: 20px;
  }
`;

export const SectionRow = styled.div`
  display: flex;
  gap: 32px;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const FeatureRow = styled.div`
  display: flex;
  gap: 24px;
  flex: 1;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const FeatureList = styled.ul`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

export const FeatureListItem = styled.li`
  position: relative;

  h4 {
    font-size: 16px;
    margin: 0 0 8px;
  }

  p {
    font-weight: 300;
    font-size: 14px;
    line-height: 1.2;
    margin: 0;
  }

  &::before {
    content: " ";
    display: inline-block;
    width: 16px;
    height: 16px;
    background: url("/images/smb/icon-green-check.png") 0 0 no-repeat;
    background-size: cover;
    position: absolute;
    top: 18px;
    left: 0;
  }

  padding: 16px 0 16px 32px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`;

export const FeatureItemArrow = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  flex-shrink: 0;
  fill: rgb(39, 195, 141);
  opacity: 0.8;
  
  @media (max-width: 991px) {
    transform: rotate(90deg);
  }
`;

export const FeatureListImg = styled.div`
  width: 100px;
  height: 100px;
  margin: 32px auto;

  img {
    width: 100%;
  }
`;

export const StepSection = styled.div`
  padding: 100px 0;

  h3 {
    text-align: center;
  }

  ${FeatureList} {
    flex-direction: row;
    gap: 44px;
  }

  ${FeatureListItem} {
    border-bottom: none;
    text-align: center;
    padding: 0;

    &::before {
      display: none;
    }

    h4 {
      margin-bottom: 12px;
    }
  }

  @media (max-width: 991px) {
    ${FeatureList} {
      flex-direction: column;
      align-items: center;
    }
  }
`;

export const ContactRow = styled.div`
  display: flex;
  background-color: #fafafa;
`;

export const ContactSection = styled.div`
  background-color: #fafafa;
  padding: 64px 0;
  display: flex;
  justify-content: space-between;

  h3 {
    margin: 0 0 16px;
    max-width: 540px;
  }

  p {
    margin: 0;
  }

  h4 {
    margin: 8px 0 0;
  }

  h4,
  a {
    color: #27c38d;
    text-decoration: none;
  }

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;

export const ContactModalBody = styled.div`
  margin: 0 auto;
  text-align: center;

  input {
    max-width: 360px;
    width: 100%;
    margin: 0 auto;
    border-radius: 30px;
    border: 1px solid #6ECFB2;
    padding: 11px 15px;
    background-color: #0c604e;
    color: #fff;
    
    ::placeholder {
      color: rgba(255, 255, 255, 0.8);
      opacity: 1; 
    }
    :focus{
      border: 1px solid #6ECFB2;
      padding: 11px 15px;
      background-color: #0c604e;
      color: #fff;
      box-shadow: none;
    }
  }
  .form-group{
    max-width: 360px;
    width: 100%;
    margin-top: 0px;
  }

  button {
    :hover{
      opacity: 1;
    }
  }
`;

export const SmbWrapper = styled.div`
  min-height: 100vh;
  background-color: #e8f6eb;
  position: relative;
`;

export const SmbMain = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 181px);
    @media (max-height: 900px) {
    height: 100vh;
  }
  @media (max-width: 768px) {
    height: 100vh;
  }
`;

export const SmbInfoContainer = styled.div`
  padding: 64px 0;
  h3 {
    color: #212529;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px; /* 125% */
    letter-spacing: -0.32px;
  }
`;

export const SmbInfoForm = styled.div`
  paddingTop: 40px;
`;

export const SmbInfoCard = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
  box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.10), 0 4px 15px 0 rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  .card-title {
    display: flex;
    gap: 24px;
    items-align: stretch;
    @media (max-width: 768px) {
      flex-direction: column;
    }
    .card-title-number { 
      display: flex;
      width: 40px;
      height: 40px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 20px;
      background: #38C3A8;
      color: #FFF;  
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 30px;
    }
    span{
      margin-top: 8px;
      color: #212529;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 30px;
    }
  }
  .info-text{
    padding-left: 64px;
    display: flex;
    gap: 4px;
    items-align: stretch;
      color: #333;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
  }
  .form-group{
    padding-left: 64px;
    width: 100%;
    @media (max-width: 768px) {
    margin-top: 0;
    }
  }
  .custom-radio {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    user-select: none;
  }

  .custom-radio-wrapper {
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    max-width: 600px;
    justify-content: space-between;
  }
  .custom-radio input[type="radio"] {
    display: none;
  }

  .custom-radio .radio-icon {
    width: 16px;
    height: 16px;
    background-size: cover;
    background-position: center;
    margin-right: 12px;
  }

  .custom-radio input[type="radio"]:checked + .radio-icon {
    background-image: url("/images/checked.png");
  }

  .custom-radio input[type="radio"]:not(:checked) + .radio-icon {
    background-image: url("/images/unchecked.png");
  }

  
  @media (max-width: 768px) {
    padding: 16px;
    
    .card-title {
      span {
        font-size: 20px;
        line-height: 26px;
      }
    }
    
    .info-text {
      padding-left: 0;
      gap: 8px;
    }
    
    .form-group {
      padding-left: 0;
    }
    
    .custom-radio-wrapper {
      flex-direction: column;
      align-items: flex-start;
      height: auto;
      gap: 12px;
      padding: 12px 0;
    }
  }
`;

export const SmbInfoQuote = styled.div`
  flex: 1;
  padding: 24px 20px;
  background-color: #fafafa;
  color: #999;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  font-style: italic;
  font-weight: 300;

  i {
    fill: #eee;
    width: 52px;
    height: 52px;
  }

  h6 {
    font-size: 20px;
    text-transform: capitalize;
    margin: 0 0 20px;
    font-weight: 300;
    padding: 0 12px;
  }

  p {
    font-size: 14px;
    margin: 0;
    padding: 0 12px;
  }
`;

export const FormLabelDesc = styled.p`
  font-size: 14px;
  font-weight: 300;
`;

export const SmbInfoNumber = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  color: #14305e;
  background-color: #27c38d;
  margin-right: 8px;
  font-size: 14px;
  font-weight: 700;
`;
